
import api from "@/api";
import { Component, Vue } from "vue-property-decorator";
import CancelButton from "../buttons/CancelButton.vue";
import EditButton from "../buttons/EditButton.vue";
import InfoDialog from "../dialogs/InfoDialog.vue";
import EditFrame from "../EditFrame.vue";

@Component({
  components: {
    EditFrame,
    EditButton,
    CancelButton,
    InfoDialog,
  },
})
export default class Documents extends Vue {
  showInfoAGBDialog = false;
  showInfoDataDialog = false;

  onInformAGB() {
    this.showInfoAGBDialog = false;
    api.NotifyApi.notifyGtc();
  }

  onInformData() {
    this.showInfoDataDialog = false;
    api.NotifyApi.notifyGdpr();
  }

  onCancel() {
    this.showInfoAGBDialog = false;
    this.showInfoDataDialog = false;
  }
}
